import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import moment from "moment";

export interface SubsInfo {
  subscription_duration_days?: number;
  subscription_date?: string;
  subscription_expiry?: string;
  stripe_order_id?: string;
  subscription_status?: number;
  stripe_price_id?: string;
  has_customer_portal?: boolean;
  trail_duration_left?: number;
}
export interface UserState {
  language: string;
  referred_by_id: number;
  referral_code: string;
  smart_allocation_tnc_accepted: boolean | undefined;
  subscription: boolean | number;
  subscription_info: SubsInfo;
  user_id: number;
  loading: boolean;
  role?: string;
  can_have_trail?: boolean;
  _2fa_enabled?: boolean;
  user_name?: string;
  completed_onboarding?: string[];
  rewardful_affiliate_id?: string | number;
}

const initialState: UserState = {
  language: "",
  referral_code: "",
  referred_by_id: 0,
  smart_allocation_tnc_accepted: undefined,
  subscription: false,
  subscription_info: {},
  user_id: 0,
  loading: true,
  _2fa_enabled: undefined,
  completed_onboarding: undefined,
  rewardful_affiliate_id: undefined,
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setUser(state, action: PayloadAction<UserState>) {
      state.language = action.payload.language;
      state.referral_code = action.payload.referral_code;
      state.referred_by_id = action.payload.referred_by_id;
      state.smart_allocation_tnc_accepted =
        action.payload.smart_allocation_tnc_accepted;
      state.subscription = action.payload.subscription;
      state.subscription_info = action.payload.subscription_info;
      state.user_id = action.payload.user_id;
      state.loading = false;
      state.role = action.payload.role;
      state.can_have_trail = action.payload.can_have_trail;
      state.user_name = action.payload.user_name;
      state.completed_onboarding = action.payload.completed_onboarding;
      state.rewardful_affiliate_id = action.payload.rewardful_affiliate_id;
    },
    updateCompleted(state, action: PayloadAction<string[]>) {
      state.completed_onboarding = action.payload;
    },
    updateSubscription(
      state,
      action: PayloadAction<{
        subscription: boolean;
        start?: number;
        end?: number;
      }>,
    ) {
      state.subscription = action.payload.subscription;
      if (
        action.payload.subscription &&
        action.payload.start &&
        action.payload.end
      )
        state.subscription_info = {
          trail_duration_left: 14,
          subscription_date: moment.unix(action.payload.start).toISOString(),
          subscription_expiry: moment.unix(action.payload.end).toISOString(),
        };
    },
    toggleLoading(state, action: PayloadAction<boolean>) {
      state.loading = action.payload;
    },
    set2fa(state, action: PayloadAction<boolean>) {
      state._2fa_enabled = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase("clear", () => {
      return initialState;
    });
  },
});

export const {
  setUser,
  toggleLoading,
  updateSubscription,
  set2fa,
  updateCompleted,
} = userSlice.actions;
export default userSlice.reducer;
